import { httpClient } from '../http-client/http-client';
import { apiConstants } from './apiConstants';

const referralPayoutAmount = () => {
  const url = apiConstants.referralPayoutAmount;
  return httpClient.get(url).then(result => result);
};


export { referralPayoutAmount };
